import {
	VEHICLE_USAGE_TYPE,
	type VehicleUsageType,
} from "../../types/vehicle-usage.types";
import { BookingType, type VehicleUsageDto } from "@/lib/api";

/**
 * Classifies a usage from its (optional) booking reference:
 * - no booking or a SYNTHETIC booking → private/owner-driven usage,
 * - a resolved booking with an UNKNOWN or absent type → unclassified,
 * - any other booking type (STANDARD, EXPRESS, …) → a regular booking.
 *
 * Shared by the active-usage and usage-history mappers so both surface the same
 * "Type" classification.
 */
export function toVehicleUsageType(
	booking: VehicleUsageDto["booking"]
): VehicleUsageType {
	if (!booking || booking.bookingType === BookingType.SYNTHETIC) {
		return VEHICLE_USAGE_TYPE.PRIVATE_USAGE;
	}
	if (!booking.bookingType || booking.bookingType === BookingType.UNKNOWN) {
		return VEHICLE_USAGE_TYPE.UNKNOWN;
	}
	return VEHICLE_USAGE_TYPE.BOOKING;
}
